import React from "react";
import { Box } from "@mui/material";
import { DotLegalHeader, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useRiskLevelStyles } from "./riskLevels.styles";
import { RiskLevelIndicator } from "./riskLevelIndicators";
import { RiskLevelIndicatorPicker } from "./RiskLevelIndicatorPicker";

export interface IRiskLevelLabelList {
    title: string;
    values: string[];
    onChange: (index: number, value: string) => void;
    indicators?: RiskLevelIndicator[];
    onIndicatorChange?: (index: number, indicator: RiskLevelIndicator) => void;
}

export function RiskLevelLabelList(props: IRiskLevelLabelList) {
    const styles = useRiskLevelStyles();

    return (
        <Box>
            <DotLegalHeader headerStyle="small" color="primary" marginTop={2} marginBottom={0.5}>
                {props.title}
            </DotLegalHeader>
            {props.values.map((value, index) => (
                <Box key={index} sx={styles.labelRow}>
                    <Box sx={styles.labelNumber}>{index + 1}.</Box>
                    {props.indicators && props.onIndicatorChange && (
                        <Box sx={styles.labelIcon}>
                            <RiskLevelIndicatorPicker value={props.indicators[index]} onChange={(indicator) => props.onIndicatorChange!(index, indicator)} />
                        </Box>
                    )}
                    <Box sx={styles.labelField}>
                        <DotLegalTextField label="" debounce={false} size="small" value={value} onChange={(newValue) => props.onChange(index, newValue)} />
                    </Box>
                </Box>
            ))}
        </Box>
    );
}
